import angular from 'angular';
import {ModalQrFormComponent} from './qrModal.component.js';
import {QrCodeScanComponent} from './qrCodeScan.component.js';

const qrScanner = angular.module('qrScanner', []);
qrScanner.component('modalQr', ModalQrFormComponent);
qrScanner.component('qrScan', QrCodeScanComponent);

export {qrScanner};



// WEBPACK FOOTER //
// ./app/components/common/qrCodeScanner/qrCodeScanner.js